import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3ead5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-express flex-center-col" }
const _hoisted_2 = {
  key: 0,
  class: "shop-title"
}
const _hoisted_3 = { class: "shop-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-ter" }
const _hoisted_6 = { class: "fx-1 flex-col" }
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_11 = ["href"]

import { t } from '@/plugins/i18n'
import { ref, computed, reactive, onMounted } from 'vue'
import { useRequest } from '@/util/useLoading'
import { expressCostPdf, isKO, isEN, isJA, isD2C } from '@/store'
import {
  RecommendedLogistics,
  getCustomerShopShipListApi,
  getShopLogistics,
  updateShopLogistics,
  editConfigShopShipApi,
  addConfigShopShipApi
} from '@/apis/setup'
import { ElMessage } from 'element-plus'
import setName from '@/util/useArea'
import { getCustomerShop } from '@/apis/order'
import { adt } from '@/util/useData'
import { useStore } from 'vuex'
import { myShopIcons } from '@/store/modules/bussiness'
import { Site } from '@/common/const'
import { getTotalCountryList } from '@/util/useCountry'
import { throughCountryGetExpressApi } from '@/apis/user'


export default /*#__PURE__*/_defineComponent({
  emits: ['ok'],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const store = useStore()
const curShop = computed(() => store.state.route.curShop)
const userInfo = computed(() => store.getters.user)
const logisticsId = ref('')
// 物流公司
const expresses: any = ref([])

const shopInfo = computed(() => {
  let shop = {}
  store.getters.user.customerShopList.forEach((item: any) => {
    if (item.customerShopId === store.state.route.curShop) {
      shop = item
    }
  })
  const shopInfoDefault = store.state.route.shopInfo
  return (shopInfoDefault.customerShopName || shopInfoDefault.customerShopPlatName) ? shopInfoDefault : shop
})
onMounted(() => {
  init()
})
const country:any = ref({})
const countryCode = ref('')
const activeCountry:any = ref({})
const init = async () => {
  const list = await getTotalCountryList()
  country.value = list.find((v) => v.code === userInfo.value.nationCode)
  countryCode.value = country.value.code ?? (isJA() ? 'JA' : isKO() ? 'KR' : 'GB')
  const expressData = await throughCountryGetExpressApi({
    countryCode: countryCode.value,
    systemSource: isD2C() ? 1 : 2
  })
  expresses.value = expressData.data
  console.log('expresses.value', expresses.value)
  if (!store.getters.curShop) return
  const resData: any = await getCustomerShopShipListApi()
  const expressConfig = resData.data?.find((item:{countryCode:string}) => item.countryCode === countryCode.value)
  if (expressConfig) {
    activeCountry.value = expressConfig
    logisticsId.value = expressConfig.logisticsId
  }
}
const wareName = ref(null)
if (store.state.route.curShop) {
  getCustomerShop().then((res: any) => {
    if (res.success) {
      const warehouseList = res.data?.warehouseList ?? []
      // 表结构变了，换种形式获取仓库名称
      wareName.value = warehouseList.find((item) => item.warehouseCountry === 'CN')?.warehouseNameTranslate
    }
  })
}

const update = async () => getShopLogistics().then(async (res) => {
  const data = res.data
  if (data) {
    data.addressAddition = data.addressAdditionRespDTO ?? {}
    const adtRes = await adt().then((data) => {
      return data.deliveryAdditionList.map((v: any) => {
        const t = { ...v }
        return t
      })
    })
    data.additionList = adtRes.filter((v: any) => (data.additionItemList ?? []).find((v2: any) => v2.additionCode === v.additionCode))
    delete data.addressAdditionRespDTO
    delete data.additionItemList
  }
  await setName(data.addressAddition)
  return data
})

const [loading, api] = useRequest(updateShopLogistics)
let origin = {
  additionList: [],
  addressAddition: {
    sendName: '',
    countryCode: '',
    sendTel: '',
    area: '',
    areaName: '',
    city: '',
    cityName: '',
    address: '',
    email: '',
    postalCode: '',
    logisticsId: '',
    logisticsName: ''
  }
}
if (store.getters.curShop) {
  origin = (
  ([__temp,__restore] = _withAsyncContext(() => update())),
  __temp = await __temp,
  __restore(),
  __temp
)
}

const data = reactive(origin)
const updateLogistics = async (isNewCustomer: any) => {
  let res = null
  if (activeCountry.value.customerShopShipId) {
    res = await editConfigShopShipApi({
      countryCode: countryCode.value,
      customerShopShipId: activeCountry.value.customerShopShipId,
      logisticsId: logisticsId.value
    })
  } else {
    res = await addConfigShopShipApi({
      countryCode: countryCode.value,
      logisticsId: logisticsId.value
    })
  }
  if (res.success) {
    emit('ok')
  }
}

// RecommendedLogistics().then((res) => {
//   if (res.success) {
//     expresses.value = res.data
//   }
// })

const checkForm = (success: any, error: any) => {
  if (logisticsId.value) {
    success()
  } else {
    error()
  }
}

expose({
  // 修改配置
  updateLogistics,
  checkForm
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(curShop) || _unref(shopInfo).customerShopName || _unref(shopInfo).customerShopPlatName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(myShopIcons)[_unref(shopInfo).shopPlatform || _unref(shopInfo).customerShopPlatform],
              alt: ""
            }, null, 8, _hoisted_4),
            _createElementVNode("span", null, _toDisplayString(_unref(shopInfo).customerShopName || _unref(shopInfo).customerShopPlatName), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", {
            style: _normalizeStyle([{"word-break":"break-word"}, {width: _unref(isKO)() ? '140px' :_unref(isEN)()?'200px': '120px' }])
          }, _toDisplayString(_unref(t)('店铺仓库所在地')) + "：", 5),
          _createElementVNode("span", null, _toDisplayString(wareName.value ?? '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", {
            style: _normalizeStyle([{"word-break":"break-word"}, {width: _unref(isKO)() ? '140px' :_unref(isEN)()?'200px': '120px' }])
          }, _toDisplayString(_unref(t)('寄往国家')) + "：", 5),
          _createElementVNode("span", null, _toDisplayString(_unref(isJA)() ? country.value.nameJa : ''), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(isKO)() ? country.value.nameKr : ''), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(isEN)() ? country.value.nameEn : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", {
            style: _normalizeStyle([{"word-break":"break-word"}, {width: _unref(isKO)() ? '140px':_unref(isEN)()?'180px':'120px'}])
          }, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(_unref(t)('选择物流公司')) + "：", 1)
          ], 4),
          _createVNode(_component_el_select, {
            modelValue: logisticsId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((logisticsId).value = $event)),
            style: {"width":"424px","height":"44px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expresses.value, (v) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: v.intShipConfigId,
                  value: v.intShipConfigId,
                  label: v.distribution
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("a", {
            class: "light rel",
            style: {"text-decoration":"underline","left":"8px","top":"7px","transform":"scale(.8)"},
            target: "_blank",
            href: _unref(expressCostPdf)()
          }, _toDisplayString(_unref(t)('国际料金表')), 9, _hoisted_11)
        ])
      ])
    ])
  ], 512)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})